/**
 * Admin Portal Reset Pots Hook
 *
 * React Query mutation hook for resetting pot data in development.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { potsApi, type ResetPotsResponse } from '../api/potsApi';

/**
 * Hook for resetting all pot data for the organisation.
 * On success, invalidates the time query since time is also reset.
 *
 * @returns Mutation hook with reset function and state
 */
export const useResetPots = () => {
  const queryClient = useQueryClient();

  return useMutation<ResetPotsResponse, Error>({
    mutationFn: potsApi.resetPots,
    onSuccess: () => {
      // Invalidate time query since time was reset
      queryClient.invalidateQueries({ queryKey: ['dev', 'time'] });
    },
  });
};
